import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './LivewireLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var LivewireLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "LivewireLogo", src: logo, alt: strings.app.name });
};
